module.exports = __webpack_public_path__ + "static/img/icon4.d7bf8892.png";